import { Component, EventEmitter, HostListener, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MemberPaths } from 'src/app/constants/routes';
import { BenefitWidgetWizardPanel } from 'src/app/constants/wizard-panels';
import { EnrollmentBenefitCategory } from 'src/app/models/enrollment-category';
import { EnrollmentWidgetService } from 'src/app/services/enrollment-widget.service';
import { WidgetError, WidgetIFrameLoader } from 'src/app/models/widget';

@Component({
    selector: 'mwp-benefit-enrollment-wizard-widget',
    templateUrl: './wizard-widget.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitEnrollmentWidgetComponent implements OnInit {
    @Output() emitWizardComplete: EventEmitter<EnrollmentBenefitCategory> = new EventEmitter();
    @Output() emitWidgetError: EventEmitter<WidgetError> = new EventEmitter();

    public route = MemberPaths;
    public panelType = BenefitWidgetWizardPanel;
    public selectedPanel: string;
    public isLoading: boolean;
    public isNotConfigured: boolean;
    public panelWidgetEnrollment: boolean;
    public currentUrl: string;
    public errorPanelName: string;

    constructor (
        private enrollmentWidgetService: EnrollmentWidgetService,
    ){
    }

    ngOnInit() {
        this.isLoading = true;
        this.enrollmentWidgetService.initializeSerivce().subscribe((response: WidgetIFrameLoader) => {
            if (response.isWidgetError) {
                this.emitWidgetError.emit(response.widgetErrorModel);
            } else {
                this.currentUrl = response.url;
                this.panelWidgetEnrollment = true;
            }
            this.isLoading = false;
        });
    }

    @HostListener('window:message', ['$event']) onMessage(event: any) {
        switch (event.data) {
            case BenefitWidgetWizardPanel.error:
                this.enrollmentWidgetService.getError().subscribe((response: EnrollmentBenefitCategory) => {
                    this.emitWidgetError.emit(response.widgetErrorModel);
                });
                break;

            case BenefitWidgetWizardPanel.finalize:
                this.enrollmentWidgetService.getFinalize().subscribe((response: EnrollmentBenefitCategory) => {
                    this.exitWizard(response);
                });
                break;

            default:
                this.errorPanelName = event.data;
                this.resetAllPanels();
                this.setError();
                break;
        }
    }

    private resetAllPanels(): void {
        this.currentUrl = null;

        this.isLoading =
            this.panelWidgetEnrollment = false;
    }

    private setError() {
        this.isNotConfigured = true;
    }

    private exitWizard(category: EnrollmentBenefitCategory): void {
        this.emitWizardComplete.emit(category);
    }
}
